import { render, staticRenderFns } from "./PartUserTabs.vue?vue&type=template&id=e89b5eba&scoped=true&"
import script from "./PartUserTabs.vue?vue&type=script&lang=js&"
export * from "./PartUserTabs.vue?vue&type=script&lang=js&"
import style0 from "./PartUserTabs.vue?vue&type=style&index=0&id=e89b5eba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89b5eba",
  null
  
)

export default component.exports